<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'SupportVideoCenter', to: { path: '/video-center' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>[Video/Weninar]項目</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toSupportVideoCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增項目</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <SupportVideoCenterTable></SupportVideoCenterTable>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SupportVideoCenterTable from '@/views/E-6__SupportVideos/c/VideoCenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    SupportVideoCenterTable,
  },
  created() {
    this.clear();
    this.getSupportVideoList();
  },
  methods: {
    ...mapActions('supportvideo', {
      getSupportVideoList: 'find',
      clear: 'clear',
    }),
    toSupportVideoCreate() {
      this.$router.push('/video-center/create');
    },
  },
};
</script>

<style></style>
